/**
 * @generated SignedSource<<4f06a33cd96340872734123280ccab48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SubscribersCountQuery$variables = {};
export type SubscribersCountQuery$data = {
  readonly subscribersCount: number | null;
};
export type SubscribersCountQuery = {
  response: SubscribersCountQuery$data;
  variables: SubscribersCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "subscribersCount",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscribersCountQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SubscribersCountQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "3d3974433e52ab9a2d62fbf964e4144c",
    "id": null,
    "metadata": {},
    "name": "SubscribersCountQuery",
    "operationKind": "query",
    "text": "query SubscribersCountQuery {\n  subscribersCount\n}\n"
  }
};
})();

(node as any).hash = "223f0da645bdd98caf009c3558d05c4b";

export default node;
